var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-config-container" },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "奖励名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderId", $$v)
                      },
                      expression: "searchForm.orderId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.changeTime },
                    model: {
                      value: _vm.searchForm.times,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "times", $$v)
                      },
                      expression: "searchForm.times",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                    [_vm._v("添加额外奖励")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                "max-height": _vm.maxHeight,
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  width: "60",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "奖励内容", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "参与活动",
                  prop: "couponBame",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "满足次数",
                  prop: "shareCouponName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "领取次数",
                  prop: "expandFail",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "添加时间",
                  prop: "actTime",
                  align: "center",
                  width: "300",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", prop: "actStatus", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("领取记录")]
                        ),
                        _vm._v(" "),
                        _c("el-button", { attrs: { size: "mini" } }, [
                          _vm._v("移除"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加额外奖励",
            visible: _vm.showAddDialog,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              attrs: {
                model: _vm.addForm,
                rules: _vm.addFormRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "额外奖励类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: !!_vm.addForm.id },
                      on: { change: _vm.handleRewardTypeChange },
                      model: {
                        value: _vm.addForm.rewardType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "rewardType", $$v)
                        },
                        expression: "addForm.rewardType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "积分", value: "points" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "礼券", value: "coupon" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "额外奖励内容" } },
                [
                  _vm.addForm.rewardType === "points"
                    ? _c("el-input", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          min: 1,
                          placeholder: "请输入积分",
                          disabled: !!_vm.form.id,
                        },
                        model: {
                          value: _vm.addForm.rewardValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "rewardValue", _vm._n($$v))
                          },
                          expression: "addForm.rewardValue",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.addForm.rewardType === "coupon"
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: {
                            placeholder: "请输入礼券，支持模糊查询",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.fetchCoupons,
                            loading: _vm.couponLoading,
                            disabled: !!_vm.addForm.id,
                          },
                          model: {
                            value: _vm.addForm.rewardValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.addForm, "rewardValue", $$v)
                            },
                            expression: "addForm.rewardValue",
                          },
                        },
                        _vm._l(_vm.couponOptions, function (coupon) {
                          return _c("el-option", {
                            key: coupon.typeId,
                            attrs: {
                              label: coupon.typeName,
                              value: coupon.typeId,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参与活动", prop: "title" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        placeholder: "选择活动名称",
                        clearable: "",
                      },
                      model: {
                        value: _vm.addForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "status", $$v)
                        },
                        expression: "addForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待完成", value: "todo" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "可领取", value: "ready" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已领取", value: "done" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "领取中", value: "loading" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参与限制" } },
                [
                  _vm._v("\n                每满"),
                  _c("el-input", {
                    staticStyle: { width: "50px", margin: "0 10px" },
                    model: {
                      value: _vm.addForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "title", $$v)
                      },
                      expression: "addForm.title",
                    },
                  }),
                  _vm._v("次可领额外奖励\n            "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.addForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "status", $$v)
                        },
                        expression: "addForm.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "启用", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "未启用", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showAddDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitAddForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }